/**
 * Calcula o número de dias úteis entre duas datas
 * @param startDate Data inicial
 * @param endDate Data final
 * @returns Número de dias úteis
 */
export function calculateBusinessDays(startDate: Date, endDate: Date): number {
  let count = 0;
  const current = new Date(startDate);

  while (current <= endDate) {
    const dayOfWeek = current.getDay();
    // 0 = Domingo, 6 = Sábado
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      count += 1;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
}

/**
 * Calcula o número de dias corridos entre duas datas
 * @param startDate Data inicial
 * @param endDate Data final
 * @returns Número de dias corridos
 */
export function calculateTotalDays(startDate: Date, endDate: Date): number {
  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

/**
 * Calcula quantos dias úteis se passaram desde a formalização
 * @param formalizationDate Data de formalização
 * @returns Número de dias úteis
 */
export function getBusinessDaysSinceFormalization(formalizationDate: string): number {
  if (!formalizationDate) return 0;

  const formalizationDateObj = new Date(formalizationDate);
  const today = new Date();

  return calculateBusinessDays(formalizationDateObj, today);
}

/**
 * Calcula quantos dias corridos se passaram desde a formalização
 * @param formalizationDate Data de formalização
 * @returns Número de dias corridos
 */
export function getTotalDaysSinceFormalization(formalizationDate: string): number {
  if (!formalizationDate) return 0;

  const formalizationDateObj = new Date(formalizationDate);
  const today = new Date();

  return calculateTotalDays(formalizationDateObj, today);
}

/**
 * Verifica se passaram mais de 7 dias úteis desde a formalização
 * @param formalizationDate Data de formalização
 * @returns true se passaram mais de 7 dias úteis
 */
export function isMoreThanSevenBusinessDays(formalizationDate: string): boolean {
  if (!formalizationDate) return false;

  const formalizationDateObj = new Date(formalizationDate);
  const today = new Date();

  const businessDays = calculateBusinessDays(formalizationDateObj, today);

  return businessDays > 7;
}
